import { isEmpty, isEqual, xorWith } from 'lodash';

const isArrayEqual = (x, y) => isEmpty(xorWith(x, y, isEqual));

export default isArrayEqual;
